/** wa.me expects an international number without `+`, spaces or punctuation. */
export const PUBLIC_WHATSAPP_PHONE = "5491124061361";

/**
 * Deliberately separate from the public-site number: today they resolve to the
 * same inbox, but the course team can move to a dedicated support line without
 * coupling the player to the landing page.
 */
export const COURSE_PLAYER_WHATSAPP_PHONE =
  import.meta.env.VITE_COURSE_SUPPORT_WHATSAPP_PHONE || PUBLIC_WHATSAPP_PHONE;

export function whatsappHref(text: string, phone = PUBLIC_WHATSAPP_PHONE): string {
  return `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
}
